import { ADDRESS_LABELS, COUNTIES, COUNTY_LABELS, CITY_EIRCODES } from '~/constants/addresses';
import compact from 'lodash/compact';

class Address {
  constructor (rawAddress) {
    this.rawAddress = rawAddress;
    this.canonicalise();
  }

  canonicalise () {
    let address = { eircode: this.rawAddress.eircode };
    if (this.rawAddress.county) {
      address.county = this.rawAddress.county;
    } else {
      // search in the fields in the Eircode DB most likely to contain a canonical county name
      for (let i = 0; i < COUNTY_LABELS.length; i++) {
        let component = this.rawAddress[COUNTY_LABELS[i]];
        if (COUNTIES.indexOf(component) > -1) { // match on the plain text
          address.county = component;
          break;
        }
        if (this.dub6w(component)) { // match on awkward Dublin 6 W case
          address.county = 'Dublin 6W';
          break;
        }
        if (COUNTIES.map(county => county.replace(/^Co\. /, '')).indexOf(component) > -1) { // match for "Co. XXXX" variant
          address.county = 'Co. ' + component;
          break;
        }
      }
      if (address.county) { // Check for the city Eircodes for the non-Dublin cities
        let city = Object.keys(CITY_EIRCODES).find(c => address.county.match(c));
        if (city) {
          address.county = CITY_EIRCODES[city].indexOf(address.eircode.slice(0, 3)) > -1 ? city : `Co. ${city}`;
        }
      }
    }
    for (let i = 1; i <= 9; i++) { // Go through all the address components
      let component = this.rawAddress['addr_line' + i];
      if (!component) {
        continue;
      }
      component = component.toString().trim();
      // Do not include blanks, counties, or eircodes
      if (!component.length || (COUNTIES.indexOf(component) > -1) || this.dub6w(component) || this.equivalentEircodes(component, this.rawAddress.eircode)) {
        continue;
      }
      // Assign to the first available field in our address object
      for (let ii = 0; ii < ADDRESS_LABELS.length; ii++) {
        var label = ADDRESS_LABELS[ii];
        if (typeof address[label] === 'undefined') {
          address[label] = component;
          break;
        }
      };
    }
    if (this.rawAddress.town) {
      address.town = this.rawAddress.town;
    }
    if (address.eircode) {
      address.displayEircode = address.eircode.substring(0, 3) + ' ' + address.eircode.substring(3, 7);
    }
    this.canonical = address;
    this.pretty = compact(['add1', 'add2', 'add3', 'town', 'county', 'displayEircode'].map(field => address[field])).join(', ');
  }

  dub6w (str) {
    return str && str.toLowerCase().replace(/\s+/g, '').trim().match(/dublin6w/);
  }

  eircodeify (str) {
    return str && str.toUpperCase().replace(/\s+/g, '');
  }

  equivalentEircodes (a, b) {
    return a && b && this.eircodeify(a) === this.eircodeify(b);
  }

  valid () {
    return this.equivalentEircodes(this.rawAddress.eircode, this.canonical.eircode);
  }
}

export { Address };
